import { memo } from 'react';
import PropTypes from 'prop-types';
// import { useHistory } from 'react-router-dom';
// import { useKeycloak } from '@react-keycloak/web';
// import { useRecoilValue } from 'recoil';
// import { currentUserRoleState } from '../../state';

function Can({ access, children, redirectTo = '/admin-panel/dashboard' }) {
  // const history = useHistory();
  // const { keycloak } = useKeycloak();
  // const currentUserRole = useRecoilValue(currentUserRoleState);

  // if (!keycloak || (keycloak && !keycloak.authenticated)) {
  //   history.push('/');
  //   return null;
  // }

  // if (!currentUserRole) {
  //   return null;
  // }

  // if (
  //   !(
  //     (typeof access === 'string' && access === currentUserRole) ||
  //     (Array.isArray(access) && access.includes(currentUserRole))
  //   )
  // ) {
  //   history.push(redirectTo);
  //   return null;
  // }

  return children;
}

Can.propTypes = {
  access: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  children: PropTypes.any.isRequired,
  redirectTo: PropTypes.string,
};

export default memo(Can);
